import React from "react";
import SlideItems from "./SlideItems";

export default function Slide({ language }) {
  return (
    <div className="slide">
      <SlideItems language={language} />
    </div>
  );
}
